<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              :placeholder="$t('search')"
              v-model="search"
              hide-details
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="listLanguages"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="_id"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">
                    <td>
                      <i class="success--text icon material-icons" v-if="props.item.active"> check_circle</i>
                      <i class="error--text icon material-icons" v-else> cancel</i>
                    </td>
                    <td>{{ props.item.name }}</td>
                    <td>{{props.item.iso}}</td>
                    <td>{{dateFormat(props.item.createdAt)}}</td>
                    <td>{{dateFormat(props.item.updatedAt)}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'
export default {
  components: {
  },
  data () {
    return {
      search: '',
      loading: false,
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('state'),
            value: 'active'
          },
          {
            text: this.$t('name'),
            value: 'name'
          },
          {
            text: this.$t('iso'),
            value: 'iso'
          },
          {
            text: this.$t('createdAt'),
            value: 'createdAt'
          },
          {
            text: this.$t('updatedAt'),
            value: 'updatedAt'
          }
        ]
      },
      dialog: false
    }
  },
  mounted () {
    this.initData()
  },
  computed: {
    ...mapState({
      listLanguages: state => state.languages.listLanguages,
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      init: 'languages/setInit',
      setStatus: 'events/setStatus'
    }),
    dateFormat (value) {
      return dateFormat(value, false)
    },
    async initData () {
      this.loading = true
      await Promise.all([
        this.init()
      ]).finally(() => this.loading = false)
    }
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>
<style scoped>
  .error--text {
    color: red;
  }
  .success--text {
    color: green;
  }
</style>
